import { render } from "./HeaderCarouselBannerPreview.vue?vue&type=template&id=2519af12&scoped=true"
import script from "./HeaderCarouselBannerPreview.vue?vue&type=script&lang=js"
export * from "./HeaderCarouselBannerPreview.vue?vue&type=script&lang=js"

import "./HeaderCarouselBannerPreview.vue?vue&type=style&index=0&id=2519af12&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2519af12"]])

export default __exports__